import i18n from "../../plugins/i18n";

export const errorHandling = {
  methods: {
    handleHttpError(response) {
      this.$bvToast.toast(response.toString(), {
        title: response.status || "Warning",
        autoHideDelay: 5000,
        variant: "warning"
      });
    },
    handleGraveError(error) {
      this.$bvToast.toast(i18n.t(error), {
        title: "Error",
        autoHideDelay: 5000,
        variant: "danger"
      });
    },
    handleWarning(warning) {
      this.$bvToast.toast(i18n.t(warning), {
        title: "Warning",
        autoHideDelay: 5000,
        variant: "warning"
      });
    }
  }
};
